// import confirmPassword from './validators/confirm-password.validator'

/**
 * 'AuthRegister Model'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  model (resource) {
    return Object.assign({
      email: '',
      fisrtName: '',
      lastName: '',
      zipCode: '',
      password: ''
    },
    resource
    )
  },
  rules (model = {}) {
    return {
      email: [
        {type: 'email', message: 'Ingrese una dirección de correo correcta', trigger: 'blur'},
        {required: true, message: 'El correo electrónico es requerido', trigger: 'blur'}
      ],
      firstName: [
        {required: true, message: 'El nombre es requerido', trigger: 'blur'}
      ],
      password: [
        {required: true, message: 'El password es requerido', trigger: 'blur'},
        {min: 8, message: 'Su password debe contener al menos 8 caracteres', trigger: 'blur'}
      ]
    }
    /* passwordRepeat: [
        {required: true, message: 'La contraseña es requerida', trigger: 'blur'},
        {min: 6, message: 'Su constraseña debe contener al menos 6 caracteres', trigger: 'blur'},
        {validator: confirmPassword(model), trigger: 'change'}
      ], */
  }
}



// WEBPACK FOOTER //
// ./src/models/auth-register.model.js